<template>
  <section class="photobooth" id="photoboothSection" ref="photoboothSection">
    <div class="mouseover" @mouseenter="hover = true" @mouseout="mouseOut"></div>
    <Header ref="header" v-show="hover || shouldAlwaysShowHeader" />
    <div class="main-container" id="receiver">
      <QRCodeReader @decode="qrDecoded" v-if="showQRCodeReader" />
      <div class="qreader-invoker" @click="showQRCodeReader = !showQRCodeReader" v-if="useQRCodeReader && !qrCodeData">
        <i class="fas fa-qrcode qreader-icon"></i>
        <span class="qreader-invoker-counter-indicator" v-if="shareGroup.length">
          {{ shareGroup.length }}
          <i class="fas fa-times-circle qreader-counter-reset" @click="shareGroup = []" v-if="shareGroup.length"></i>
        </span>
      </div>
      <!-- CAMERA -->
      <div class="iframecontainer" v-if="!showQRCodeReader">
        <iframe
          class="gravador"
          :class="{ usePhotoboothV2: activityData.property.usePhotoboothV2 }"
          :src="activityData.property.iframeSrc ? activityData.property.iframeSrc : activityData.property.src"
          frameborder="0"
          allow="camera; web-share"></iframe>
      </div>
      <!-- QRCode Viewer -->
      <div class="photobooth-qrcodeview" v-if="activityData.property.showHostedQRCode && images[0] && qrCodeViewerValue">
        <div class="qrcodeview-vueqr-result-img" v-if="images[0]" @click="qrCodeViewerValue = ''">
          <img class="qrcodeview-vueqr-img" :src="imageFromCamera" />
          <vue-qr class="qrcodeview-vueqr" :text="qrCodeViewerValue" qid="testid"></vue-qr>
        </div>
      </div>
      <div class="photobooth-ending-panel-container" v-if="activityData.property.showEndingPanel && imageFromCamera">
        <div class="photobooth-ending-panel">
          <label>Mensagem para usuário</label>
          <div class="flex-row">
            <el-button type="primary" @click="closeEndingPanel">Fechar</el-button>
            <el-button type="primary" @click="goNextRoute">Continuar</el-button>
          </div>
        </div>
      </div>
      <div class="gallery" :class="{ top100vh: activityData.property.usePhotoboothV2 }" v-if="!activityData.property.hidePublicGallery">
        <Gallery :activityData="activityData" :key="galleryKey" :images="images" :imagesSrc="imagesSrc" @scrollBottom="loadImages(images.length)" @scrollTop="loadImages" />
        <Footer />
      </div>
    </div>
    <Spinner :showSpinner="showSpinner" />
  </section>
</template>

<script>
import Header from '@/components/general/Header.vue';
import Gallery from '@/components/general/Gallery.vue';
import Footer from '@/components/general/Footer.vue';
import api from '@/services/api';
import Spinner from '@/components/ui/Spinner.vue';
import QRCodeReader from '@/components/general/QRCodeReader.vue';
import VueQr from 'vue-qr';

export default {
  name: 'PhotoBooth',
  components: {
    Header,
    Gallery,
    Footer,
    Spinner,
    QRCodeReader,
    VueQr,
  },
  data() {
    return {
      hover: false,
      images: [],
      activityData: { images: {}, property: {}, interactivities: [] },
      currentLastPhotoId: '',
      imageObjects: [],
      imagesSrc: [],
      userAbleToPost: false,
      galleryKey: '',
      showQRCodeReader: false,
      showSpinner: false,
      qrCodeData: null,
      shareGroup: [],
      qrCodeViewerValue: '',
      imageFromCamera: null,
      idleCounter: 0,
      idleTimeoutInSeconds: 90,
      enableIdleTimeout: false,
      screenOrientation: 'portrait',
      isMobile: false,
      apiLimit: 20,
      currentPage: 0,
      isLoadingImages: false,
      allImagesLoaded: false,
    };
  },
  watch: {
    $route() {
      this.loadActivity();
    },
  },
  computed: {
    useQRCodeReader() {
      return this.activityData.property.qrCodeReader ? this.activityData.property.qrCodeReader.enable : false;
    },
    shouldAlwaysShowHeader() {
      return this.activityData.property.alwaysShowHeaderOnPortrait && this.screenOrientation.includes('portrait');
    },
  },
  methods: {
    loadActivity() {
      api.get(`activity/${this.$route.params.stream}`).then((response) => {
        let tempImages = { ...this.activityData.images };
        this.activityData = { ...this.activityData, ...response.data };
        this.activityData.images = response.data.images ? JSON.parse(response.data.images) : tempImages;

        let tempProperty = { ...this.activityData.property };
        this.activityData.property = response.data.property ? JSON.parse(response.data.property) : tempProperty;

        if (this.activityData.property.qrCodeReader && this.activityData.property.qrCodeReader.enable && this.activityData.property.qrCodeReader.isMandatory) {
          this.showQRCodeReader = true;
        }

        if (this.activityData.property.enableIdleTimeout) {
          this.idleTimeoutInSeconds = this.activityData.property.idleTimeoutInSeconds;
          this.enableIdleTimeout = true;
        }
      });
    },
    loadMoreImagesOnScroll(e) {
      if (this.allImagesLoaded || this.isLoadingImages) return;
      if (this.$refs.photoboothSection.scrollTop + this.$refs.photoboothSection.offsetHeight >= this.$refs.photoboothSection.scrollHeight) {
        this.loadImages();
      }
      if (this.$refs.photoboothSection.scrollTop === 0) {
        if (this.currentPage === 0) return;
        this.images = [];
        this.imagesSrc = [];
        this.currentPage = 0;
        this.allImagesLoaded = false;
        this.loadImages();
      }
    },
    loadImages() {
      if (this.isLoadingImages || this.allImagesLoaded) return;
      this.isLoadingImages = true;
      const query = `?limit=${this.apiLimit}&page=${this.currentPage}`;
      api
        .get(`activity/${this.$route.params.stream}/materialList${query}`)
        .then((response) => {
          if (!Array.isArray(response.data) || response.data.length === 0) {
            this.allImagesLoaded = true;
            this.isLoadingImages = false;
            return;
          }
          let newImagesCount = 0;
          response.data.forEach((element) => {
            if (!this.images.some((img) => img.material_id === element.material_id)) {
              element.showQrCode = false;
              this.imageObjects.push(element);
              this.images.push(element);
              this.imagesSrc.push(element.links);
              newImagesCount++;
            }
          });
          if (response.data.length < this.apiLimit) {
            this.allImagesLoaded = true;
          } else {
            this.currentPage++;
          }
          this.isLoadingImages = false;
        })
        .catch((err) => {
          this.isLoadingImages = false;
          console.error(err);
        });
    },
    uploadPhoto(e) {
      try {
        if (typeof e.data === 'string' && e.data.startsWith('{') && JSON.parse(e.data).uri) {
          this.showSpinner = true;
          let packet = JSON.parse(e.data);
          this.imageFromCamera = packet.uri;
          let byteString = atob(packet.uri.split(',')[1]);
          let ab = new ArrayBuffer(byteString.length);
          let ia = new Uint8Array(ab);
          for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
          }
          let blob = new Blob([ia], {
            type: 'image/jpeg',
          });
          let file = new File([blob], `${this.$store.state.eventName}_${this.$store.state.user.name ? this.$store.state.user.name.replaceAll(' ', '') : 'Photobooth'}_${new Date().toDateString()}.jpg`, {
            type: 'image/jpeg',
          });

          let formData = new FormData();
          formData.append('file', file);
          formData.append('description', 'Photobooth picture');
          formData.append('tag', 'Photobooth');
          formData.append('properties', JSON.stringify({}));
          formData.append('public', true);

          if (this.shareGroup.length) {
            if (!this.shareGroup.includes(this.$store.state.user.id)) {
              this.shareGroup.push(this.$store.state.user.id);
            }
            const stringifiedShareGroup = JSON.stringify(this.shareGroup);
            formData.append('share', stringifiedShareGroup);
          } else {
            const ownId = JSON.stringify([this.$store.state.user.id]);
            formData.append('share', ownId);
          }

          if (file.size > 10) {
            api
              .post(`activity/${this.$route.params.stream}/materialUpload`, formData, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                },
              })
              .then((response) => {
                this.qrCodeViewerValue = `https://${location.host}/#/hosted/?material=${response.data.url}`;
                this.showSpinner = false;
                this.images = [];
                this.imagesSrc = [];
                this.shareGroup = [];

                if (!this.activityData.property.hidePublicGallery) {
                  this.currentPage = 0;
                  this.allImagesLoaded = false;
                  this.loadImages();
                }

                if (this.activityData.property.hidePublicGallery) {
                  if (this.isMobile) {
                    this.navigatorShare(response.data.url);
                  } else {
                    this.downloadImage(response.data.url);
                  }
                } else {
                  setTimeout(() => {
                    const app = document.getElementById('app');
                    if (app) {
                      this.smoothScrollTo(app, app.scrollHeight / 2, 1200);
                    }
                  }, 300);
                }

                api.post(`sessionAction/`, {
                  action: 'Photobooth upload',
                  properties: JSON.stringify({ route: this.$route.name, params: this.$route.params }),
                  userid: this.$store.state.user.id,
                  sessionid: this.$store.state.user.token,
                  event_id: this.$store.state.eventId,
                });
              })
              .catch((err) => console.error(err));
          } else {
            this.showSpinner = false;
            alert('Could not generate image, sorry');
            return;
          }
        } else {
          return;
        }
      } catch (error) {
        console.error('upload photo error', error);
      }
    },
    navigatorShare(image) {
      if (navigator.share) {
        fetch(image)
          .then((response) => response.blob())
          .then((blob) => {
            const file = new File([blob], `image-${this.$RNG.randomID()}.png`, { type: blob.type });
            navigator
              .share({
                files: [file],
              })
              .catch((error) => {
                console.error('Failed to share image.', error);
              });
          })
          .catch((error) => {
            console.error('Failed to fetch image.', error);
          });
      } else {
        console.error('Web Share API is not supported.');
      }
    },
    downloadImage(image) {
      fetch(image)
        .then((response) => response.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `image-${this.$RNG.randomID()}.png`);
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          console.error('Failed to fetch image.', error);
        });
    },
    qrDecoded({ id }) {
      this.showQRCodeReader = false;
      this.shareGroup = [...new Set([...this.shareGroup, id])];
    },
    mouseOut() {
      if (this.shouldAlwaysShowHeader) return;
      this.hover = true;
      setTimeout(() => {
        this.hover = false;
      }, 4000);
    },
    goNextRoute() {
      if (this.activityData.property.nextRoute) {
        this.qrCodeViewerValue = '';
        this.$router.push(this.activityData.property.nextRoute);
      } else {
        this.qrCodeViewerValue = '';
      }
    },
    closeEndingPanel() {
      this.qrCodeViewerValue = '';
      this.imageFromCamera = null;
    },
    createArtAI() {
      api
        .post(`event/${this.$store.state.eventId}/createArtAI/12f4aa20-bf70-11ed-a759-9376b3de501d/user/${this.$store.state.user.id}`, {
          url: 'https://images.squarespace-cdn.com/content/v1/5c62fc04ebfc7f6ac17df991/1574135342529-XW0U81SV1YCCJC9CWBCD/image.jpg',
          style: null,
          config: "`{'prompt':'cyberpunk style'}`",
          quantity: 1,
        })
        .then((response) => {})
        .catch((error) => {
          console.error(error);
        });
    },
    listenForIdleBreaks(e) {
      if (e.data === 'idleBreak') {
        this.clearTimer();
      }
    },
    startTimer() {
      if (!this.enableIdleTimeout) return;
      this.timerId = setTimeout(() => {
        this.idleCounter++;
        if (this.idleCounter >= this.idleTimeoutInSeconds) {
          this.clearTimer();
          this.$refs.header.logout();
        } else this.startTimer();
      }, 1000);
    },
    clearTimer() {
      if (!this.enableIdleTimeout) return;
      clearTimeout(this.timerId);
      if (this.idleCounter < this.idleTimeoutInSeconds) {
        this.idleCounter = 0;
        this.startTimer();
      }
    },
    updateScreenOrientation(e) {
      console.log('orientation changed to', e);
      this.screenOrientation = e.target.screen.orientation.type;
      console.log('screenOrientation', this.screenOrientation);
    },
    checkIfMobile() {
      const userAgent = navigator.userAgent.toLowerCase();
      const mobileKeywords = ['iphone', 'ipod', 'ipad', 'windows phone'];
      const isMobileDevice = mobileKeywords.some((keyword) => userAgent.includes(keyword));

      this.isMobile = isMobileDevice;
    },
    smoothScrollTo(element, target, duration = 800) {
      const start = element.scrollTop;
      const change = target - start;
      const startTime = performance.now();

      const easeInOutCubic = (t) => {
        return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
      };

      const animateScroll = (currentTime) => {
        const timeElapsed = currentTime - startTime;
        const progress = Math.min(timeElapsed / duration, 1);
        const easedProgress = easeInOutCubic(progress);

        element.scrollTop = start + change * easedProgress;

        if (progress < 1) {
          requestAnimationFrame(animateScroll);
        }
      };

      requestAnimationFrame(animateScroll);
    },
  },
  beforeMount() {
    this.loadActivity();
    this.images = [];
    this.imagesSrc = [];
    this.currentPage = 0;
    this.allImagesLoaded = false;
    this.isLoadingImages = false;
    this.loadImages();
    this.checkIfMobile();
  },
  mounted() {
    window.addEventListener('message', this.listenForIdleBreaks);
    window.addEventListener('message', this.uploadPhoto);
    this.$refs.photoboothSection.addEventListener('scroll', this.loadMoreImagesOnScroll);
    document.addEventListener('click', this.clearTimer);
    document.addEventListener('keydown', this.clearTimer);
    document.addEventListener('mousemove', this.clearTimer);
    document.addEventListener('scroll', this.clearTimer);
    window.addEventListener('orientationchange', this.updateScreenOrientation);
  },

  beforeDestroy() {
    window.removeEventListener('message', this.listenForIdleBreaks);
    window.removeEventListener('message', this.uploadPhoto);
    this.$refs.photoboothSection.removeEventListener('scroll', this.loadMoreImagesOnScroll);
    document.removeEventListener('click', this.clearTimer);
    document.removeEventListener('keydown', this.clearTimer);
    document.removeEventListener('mousemove', this.clearTimer);
    document.removeEventListener('scroll', this.clearTimer);
    window.removeEventListener('orientationchange', this.updateScreenOrientation);
  },
};
</script>

<style scoped lang="scss">
.photobooth {
  position: relative;
  background-color: var(--main-color);
  min-height: 100dvh;

  @include media('<=phone-plus') {
    z-index: 1000001;
  }

  &::-webkit-scrollbar {
    width: 0;

    @media only screen and (max-height: 720px) {
      width: 10px;
    }
  }
  &::-webkit-scrollbar-track {
    background-color: rgb(70, 69, 66);
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgb(102, 102, 102) !important;
    border-radius: 4px;
    background-image: none !important;
  }
}
.mouseover {
  position: absolute;
  left: 0;
  pointer-events: auto;
  top: 0px;
  width: 98vw;
  height: 120px;
}
.main-container {
  display: flex;
  flex-wrap: wrap;

  .qreader-invoker {
    position: absolute;
    top: calc(100vw * 9 / 16 - 88px);
    padding: 14px 20px;
    z-index: 1;
    background-color: var(--main-color);
    text-align: center;
    transition: background-color 300ms;

    @media only screen and (min-width: 1680px) {
      top: calc(100vw * 9 / 16 - 224px);
    }

    @media only screen and (max-width: 440px) {
      display: none;
    }

    .qreader-invoker-counter-indicator {
      position: absolute;
      top: -10px;
      right: -10px;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      background-color: #fff;
      color: black;
      font-size: 1.08rem;
      font-weight: bold;
      z-index: 20;

      display: flex;
      justify-content: center;
      align-items: center;

      .qreader-counter-reset {
        position: absolute;
        top: -10px;
        right: -10px;
        border-radius: 50%;
        background-color: #fff;
        color: black;
        font-weight: bold;
        z-index: 1;

        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .qreader-icon {
      font-size: 4rem;
      cursor: pointer;
      transition: background-color 300ms;
      &:hover {
        background-color: #333;
      }
      &:active {
        transform: scale(0.9);
      }
    }
  }

  .iframecontainer {
    overflow-x: hidden;
    padding-left: 0;
    max-width: 100vw;
    .gravador {
      overflow: hidden !important;
      width: 100vw;
      height: calc(100dvh + 25.25vw);
    }
    .usePhotoboothV2 {
      height: 100dvh;
    }
  }

  .gallery {
    background-color: transparent;
    position: absolute;
    top: calc(100px + 50.25vw);

    @include media('<=tablet') {
      top: calc(70px + 50.25vw);
    }
  }

  .top100vh {
    top: 100dvh;
  }
}
.sticky-footer {
  position: relative;
  bottom: 0px;
}

.photobooth-qrcodeview {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100%;
  background-color: #000a;
  z-index: 1000000;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .qrcodeview-vueqr-result-img {
    position: relative;
    .qrcodeview-vueqr-img {
      height: 100dvh;

      @media only screen and (orientation: portrait) {
        width: 100vw;
        height: auto;
      }
    }

    .qrcodeview-vueqr {
      position: absolute;
      left: 10px;
      bottom: 10px;

      @media only screen and (orientation: portrait) {
        left: 50%;
        bottom: 50%;
        transform: translate(-50%, 50%);
      }
    }
  }
}
.photobooth-ending-panel-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000000;

  @media only screen and (orientation: portrait) {
    height: 45%;
  }

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;

  .photobooth-ending-panel {
    position: relative;
    padding: 20px;
    background-color: #000a;
    border-radius: 10px;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
    label {
      position: relative;
      font-size: 1.5rem;
      font-weight: bold;
    }
  }
}

.photobooth-create-artai-btn {
  position: absolute;
  top: calc(100vw * 9 / 16 - 88px);
  left: calc(50vw - 42px);
  padding: 14px 20px;
  z-index: 1;
  color: white;
  background-color: var(--main-color);
  text-align: center;
  transition: background-color 300ms;
  cursor: pointer;
}
</style>
